/* eslint-disable no-unused-vars -- Webpack consumes this runtime global. */
/* global __webpack_public_path__: writable */
// Must execute before engine imports, so split chunks come from CookUp rather
// than the ChatGPT sandbox origin. Normal studio builds keep their usual base.
if (window.__COOKUP_CHAT_ENGINE_BASE__) {
  __webpack_public_path__ = new URL('/', window.__COOKUP_CHAT_ENGINE_BASE__).href;
}
